import React, { useEffect, useState } from "react";
import { Link, Routes, Route, useNavigate, useLocation } from "react-router-dom";
import cookie from "react-cookies";
import { QtChevronLeft } from "../../components/icons/QtIcon";
import "./academy.scss";
import { getAcademyCatalog, getAcademyHome } from "../../services/academyApi";
import AcademyHome from "./AcademyHome";
import AcademyDetail from "./AcademyDetail";
import AcademyModule from "./AcademyModule";
import { scrollTrainingToTop, TrainingTypeChip, TrainingBreadcrumbs, TrainingAccountSubnav } from "./AcademyShared";
import CareersFooter from "../../components/CareersFooter";

const BASE = "/academy";

function AcademyLayout({ children, title, titleChip, onBack, showSubnav = true, breadcrumbs = null }) {
  const navigate = useNavigate();
  const location = useLocation();
  const isLoggedIn = !!cookie.load("candidateKey");

  useEffect(() => {
    scrollTrainingToTop({ instant: true });
  }, [location.pathname]);

  return (
    <div className="training-center">
      <div className="training-center__bg" aria-hidden="true" />
      <header className="training-header">
        <button
          type="button"
          className="training-header-back"
          onClick={onBack || (() => navigate(BASE))}
          aria-label="Back"
        >
          <QtChevronLeft />
        </button>
        <div className="training-header-title-wrap">
          <Link to="/" className="training-header-brand">
            QikTruck <span>Programs</span>
          </Link>
          <h1 className={`training-header-title${titleChip ? " training-header-title--with-chip" : ""}`}>
            {titleChip && <TrainingTypeChip type={titleChip} className="training-header-title__chip" />}
            <span className="training-header-title__text">{title}</span>
          </h1>
        </div>
        {isLoggedIn ? (
          <Link to="/me" className="training-header-me" aria-label="My progress">
            Me
          </Link>
        ) : (
          <Link to="/login?next=%2Facademy" className="training-header-me training-header-me--cta">
            Sign in
          </Link>
        )}
      </header>

      <div className="training-shell">
        {breadcrumbs?.length > 0 && (
          <TrainingBreadcrumbs items={breadcrumbs} className="training-shell__breadcrumbs" />
        )}
        {showSubnav && <TrainingAccountSubnav />}

        <main className="training-body">{children}</main>
      </div>
      <CareersFooter />
    </div>
  );
}

function AcademyHomePage() {
  const isLoggedIn = !!cookie.load("candidateKey");
  const [catalog, setCatalog] = useState(null);
  const [home, setHome] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    Promise.all([
      getAcademyCatalog()
        .then((data) => {
          if (!cancelled) setCatalog(data);
        })
        .catch(() => {
          if (!cancelled) setCatalog({ academies: [], academy_trees: [] });
        }),
      isLoggedIn
        ? getAcademyHome()
            .then((data) => {
              if (!cancelled) setHome(data);
            })
            .catch(() => {
              if (!cancelled) setHome(null);
            })
        : Promise.resolve(),
    ]).finally(() => {
      if (!cancelled) setLoading(false);
    });
    return () => {
      cancelled = true;
    };
  }, [isLoggedIn]);

  return (
    <AcademyLayout title="Training programs">
      <AcademyHome
        catalog={catalog}
        home={home}
        baseUrl={BASE}
        isLoggedIn={isLoggedIn}
        loading={loading}
      />
    </AcademyLayout>
  );
}

export default function AcademyCenter() {
  return (
    <Routes>
      <Route index element={<AcademyHomePage />} />
      <Route
        path=":academySlug/module/:moduleSlug"
        element={<AcademyModule Layout={(props) => <AcademyLayout {...props} showSubnav={false} />} />}
      />
      <Route
        path=":academySlug"
        element={<AcademyDetail Layout={(props) => <AcademyLayout {...props} showSubnav={false} />} />}
      />
    </Routes>
  );
}
